import React from "react";
import TablaVisitas from "../../components/visitas/TablaVisitas";

function VisitaTable() {
  return (
    <>
      <TablaVisitas />
    </>
  );
}

export default VisitaTable;
